import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FiUsersListRelatedToObjectTypeComponent } from './fi-users-list-related-to-object-type.component';
import { FiProfileIconModule } from '../profile-icon/profile-icon.module';

@NgModule({
    imports: [CommonModule, FiProfileIconModule],
    declarations: [FiUsersListRelatedToObjectTypeComponent],
    exports: [FiUsersListRelatedToObjectTypeComponent],
})
export class FiUsersListRelatedToObjectTypeModule {}
